import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { getOrgId } from '../fvid-auth/userSession';

interface IProjectTypes {
  projectTypeId: {
    native: number,
    partner: number,
  },
  name: string,
  links: {}
}

/**
 * TanStack Query version of useQueryProjectTypes
 * Fetches project types using HTTP client
 */
const useQueryProjectTypes = () => {
  const httpClient = useHttpClient();
  const orgId = getOrgId();

  return useQuery<IProjectTypes[]>({
    queryKey: ['projectTypes', orgId],
    queryFn: async () => {
      const response = await httpClient.get('/projecttypes?limit=1000');
      return response.data.projectTypes?.items || response.data.items || response.data;
    },
    enabled: !!orgId, // Only fetch when orgId is available
  });
};

export default useQueryProjectTypes;
